import { render, staticRenderFns } from "./imcNinas5a19A.vue?vue&type=template&id=c647408e&scoped=true"
import script from "./imcNinas5a19A.vue?vue&type=script&lang=js"
export * from "./imcNinas5a19A.vue?vue&type=script&lang=js"
import style0 from "./imcNinas5a19A.vue?vue&type=style&index=0&id=c647408e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c647408e",
  null
  
)

export default component.exports